import { useContext, createContext, useState } from 'react';

export type HasFooterContextProps = {
  hasFooter: boolean;
  setHasFooter: (hasFooter: boolean) => void;
};

export const HasFooterContextValues = {
  hasFooter: false,
  setHasFooter: () => null,
};

export const HasFooterContext = createContext<HasFooterContextProps>(
  HasFooterContextValues
);

export type HasFooterProviderProps = {
  children: React.ReactNode;
};

const HasFooterProvider = ({ children }: HasFooterProviderProps) => {
  const [hasFooter, setHasFooter] = useState(false);

  return (
    <HasFooterContext.Provider
      value={{
        hasFooter,
        setHasFooter,
      }}
    >
      {children}
    </HasFooterContext.Provider>
  );
};

const useHasFooter = () => useContext(HasFooterContext);

export { HasFooterProvider, useHasFooter };
